import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IRequestCallback, IRequestOptions } from '@df/api/request/request.service';
import { MultisiteService } from '@df/core/service/multisite';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { ImageModule } from '@df/module-image/image.module';
import { NgInject } from '@df/ng/ng-inject';
import { Login } from '@df/session/login/login.interfaces';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { TranslationService } from '@df/ui/translation/translation.service';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { MultisiteSwitchAdvancedComponent } from '../../../multisite/switch/advanced/multisite-switch-advanced.component';
import { TradeStoreService } from '../../../multisite/trade/trade-store.service';
import { ActionComponent } from '../../../ui/api/action.component';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { FormWizardComponent } from '../../../ui/form/wizard/form-wizard.component';
import { FormWizardStepComponent } from '../../../ui/form/wizard/step/form-wizard-step.component';
import { ResultComponent } from '../../../ui/resut/result.component';
import { LoginFormRetailComponent } from '../retail/login-form-retail.component';
import { LoginFormTradeProspectMessageBlockComponent } from './prospect-message/login-form-trade-prospect-message.component';
import { LoginFormTradeStep1Component } from './step/1/login-form-trade-step-1.component';
import { LoginFormTradeStep2Component } from './step/2/login-form-trade-step-2.component';
import { LoginFormTradeStep3Component } from './step/3/login-form-trade-step-3.component';
import { LoginFormTradeStep4Component } from './step/4/login-form-trade-step-4.component';
import { LoginFormTradeStep5Component } from './step/5/login-form-trade-step-5.component';
import { LoginFormTradeStep6Component } from './step/6/login-form-trade-step-6.component';

@Component({
    selector: 'login-form-trade',
    templateUrl: './login-form-trade.component.html',
    styleUrls: ['./login-form-trade.component.scss'],
    standalone: true,
    imports: [
        ActionComponent,
        DfUiModule,
        FormsModule,
        FormWizardComponent,
        FormWizardStepComponent,
        ICmsClientModule,
        ImageModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        LoginFormTradeProspectMessageBlockComponent,
        LoginFormTradeStep1Component,
        LoginFormTradeStep2Component,
        LoginFormTradeStep3Component,
        LoginFormTradeStep4Component,
        LoginFormTradeStep5Component,
        LoginFormTradeStep6Component,
        MuiInputDirective,
        MultisiteSwitchAdvancedComponent,
        NgClass,
        ResultComponent,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormTradeComponent extends LoginFormRetailComponent implements OnInit {
    protected tradeStoreService = inject(TradeStoreService);
    private multisiteService = inject(MultisiteService);
    private translationService = inject(TranslationService);
    @ViewChild(LoginFormTradeStep4Component)
    private loginFormTradeStep4Component?: LoginFormTradeStep4Component;
    @ViewChild(FormWizardComponent)
    private formWizardComponent?: FormWizardComponent;
    protected showLoginForm = false;
    override ngOnInit(): void {
        this.setShowLoginForm();
    }
    protected removePreferredStoreCookie(): void {
        this.multisiteService.preferredStoreId = undefined;
        this.setShowLoginForm();
    }
    protected setShowLoginForm(): void {
        this.showLoginForm = !!this.multisiteService.preferredStoreId;
        this.detectChanges();
    }
    get isTradeProspectView(): boolean {
        return this.tradeStoreService.isTradeProspect();
    }
    stepChangeHandle(): void {
        this.detectChanges();
    }
    override register(onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        if (this.content?.termsCopy && !(this.data as Login.IRegisterFormData).terms_and_conditions) {
            this.registerStatus.error = this.translationService.translate('Terms and conditions is required');
        }
        if (this.formWizardComponent?.checkStep(true, true)) {
            const data = this.dataAsRegisterFormData;
            data.company = data.sole_prop_name || data.firstname + ' ' + data.lastname;
            super.register(onSuccess, onError);
        }
    }
    protected override getRegisterRequestOptions(): IRequestOptions | undefined {
        if (this.loginFormTradeStep4Component?.tradeFileInputsData.find(data => !!data.src)) {
            return {
                fileUpload: true
            };
        }
        return undefined;
    }
    protected override getRegisterData(): Login.IRegisterFormData {
        const registerData = super.getRegisterData();
        if (this.tradeStoreService.isTradeStore()) {
            return { ...registerData, is_billing: true };
        }
        return registerData;
    }

    protected get dataAsRegisterFormData(): Login.IRegisterFormData {
        return this.data as Login.IRegisterFormData;
    }
}
